import { render, staticRenderFns } from "./CardTags.vue?vue&type=template&id=9c77f4ae"
import script from "./CardTags.vue?vue&type=script&lang=ts"
export * from "./CardTags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports